


















































































































































































    import AbpBase from "../../../lib/abpbase";
    import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';

    import {GetWardList,GetShiftList} from '../../../api/specialDictionary'
    import {GetDlys,CancelDly,FocusOn,ChangeBed,GetUserRoles,CancelBedSchedu} from '../../../api/dialysisProcess'
    import util from '../../../lib/util'
    //拼音
    import PY from '../../../lib/py'

    import tagManage from './tagManage.vue'
    import makeAdvice from './makeAdvice.vue'
    import verifyPrescription from './verifyPrescription.vue'
    import statistics from './statistics.vue'
    import dialysisBegin from './dialysisBegin.vue'
    import crosscheck from './crosscheck.vue'
    import dialysisNurse from './dialysisNurse.vue'
    import dialysisOff from './dialysisOff.vue'
    import dialysisSummary from './dialysisSummary.vue'
    import dialysisDisinfect from './dialysisDisinfect.vue'
    import dialysisSyndrome from './dialysisSyndrome.vue'
    import specialCare from './specialCare.vue'

    import makePres from '../waitRoom/makePrescription.vue'

    import weightForm from '../waitRoom/weightForm.vue'
    import actionInfo from './actionInfo.vue'
    import cancelDly from './cancelDly.vue'
    import changeBed from './changeBed.vue'
    import afterWeight from './afterWeight.vue'
    import machieRepair from './machieRepair.vue'
    import borrowedMedicine from './borrowedMedicine.vue'
    import patDlyRecord from '../../../components/patDlyRecord.vue'
    import patientInfo from '../../electronicMedicalRecord/patient/parts/patientInfo.vue'
    import education from '../../education/educationPlan/parts/detail.vue'


    @Component({
        components:{
            tagManage:tagManage,
            makeAdvice:makeAdvice,
            verifyPrescription:verifyPrescription,
            statistics:statistics,
            dialysisBegin:dialysisBegin,
            crosscheck:crosscheck,
            dialysisNurse:dialysisNurse,
            dialysisOff:dialysisOff,
            dialysisSummary:dialysisSummary,
            makePres:makePres,
            dialysisDisinfect:dialysisDisinfect,
            dialysisSyndrome:dialysisSyndrome,
            specialCare:specialCare,
            weightForm:weightForm,
            actionInfo:actionInfo,
            cancelDly:cancelDly,
            changeBed:changeBed,
            patDlyRecord:patDlyRecord,
            afterWeight:afterWeight,
            machieRepair:machieRepair,
            borrowedMedicine:borrowedMedicine,
	        patientInfo:patientInfo,
			education:education
        }
    })
    export default class  extends AbpBase{
        //患者拼音选项列表
        pylist = ['全部患者']
        //首字母检索 索引
        pyindex = 0

        //病区列表/班次列表
        wardList = []
        shiftList = []
        //当前班次
        shiftActive:any = {}
        wardId = 0
        shiftId = null
        queryString = ''
        @Watch('queryString')
        watchqueryString(){
            this.getData()
        }
        // 宣教
		educationShow = false
		educationData:any = {}
        // 当前患者信息
        activePatient:any = {}
        //透析区列表
        list = []
        listActive = []
         //////////////////////
        //确认处方
        verifyPrescriptionShow:boolean = false
        verifyPrescriptionData:any = {}

        //称量表单
        weightShow = false
        weightData = {}

        //透析记录单
        patDlyRecordShow:Boolean = false
        patDlyRecordData:any = {}
        //////////////////////
        //借还药
        borrowedMedicineShow:Boolean = false
        //修改处方//制定处方表单
        makePresShow:Boolean = false
        //标签管理
        tagsManageShow:boolean = false
        //制定医嘱
        makeAdviceShow:boolean = false
        //患者统计
        statisticsShow:boolean = false
        //透析上机
        dialysisBeginShow:boolean = false
        //透析下机
        dialysisOffShow:boolean = false
        //交叉核对
        crosscheckShow:boolean = false
        //透中护理
        dialysisNurseShow:boolean = false
        //透中小结
        dialysisSummaryShow:boolean = false
        //消毒
        dialysisDisinfectShow:boolean = false
        //记录并发症
        dialysisSyndromeShow:boolean = false
        //特殊护理
        specialCareShow:boolean = false
        //操作提示
        actionInfoShow:boolean = false
        actionInfoData:any = {}
        //取消本次透析
        cancelDlyShow:boolean = false
        //换床
        changeBedShow:boolean = false
        //透后称量
        afterWeightShow:boolean = false
        //设备报修
        machieRepairShow:boolean = false
        //删除model
        deleteModel:boolean = false
        //透析时间显示
        countDown:any = []
        //百分比
        countDownBl:any = []
        async created() {
            // this.getprice()
            await this.getUserRoles()
            await this.getWardList()
            await this.getShiftList()
            await this.getData()
        }
        async getData(){
            let data = {
                wardId:this.wardId,
                shiftId:this.shiftActive.id,
                queryString:this.queryString,
            }
            let res = await GetDlys(data)
            console.log(res)
            this.list = res.objects
            this.listActive = this.list
            //生成患者名称首字母列表
            this.pylist = ['全部患者']
            this.pyindex = 0
            let patientNamePYList = this.list.map((item:any)=>{
                return PY.instance.initialTreatment(item.patientName)
            })
            new Set(patientNamePYList).forEach(item=>{
                this.pylist.push(item)
            })
            clearInterval(this.tsetInterval)
            this.countDown = []
            this.countDownBl = []
            //透析活动时间计算开始
            this.listActive.forEach((item:any,index:any)=>{
                this.countDown.push('')
                this.countDownBl.push(0)
            })
            this.getprice(this.listActive)
        }
	    patientInfoData:any = {}
	    patientInfoShow = false
	    showPatientInfo(item:any){
        	this.patientInfoData = {
        		id: item.patientId,
		        patientName: item.patientName
	        }
	        this.patientInfoShow = true
	    }
        //获取病区
        async getWardList(){
            let data = {
                QueryString:'',
                SkipCount:1,
                MaxResultCount:10000
            }
            let res = await GetWardList(data)
            this.wardList = res.items
        }
        //获取班次
        async getShiftList(){
            let data = {
                QueryString:'',
                SkipCount:1,
                MaxResultCount:10000
            }
            let res = await GetShiftList(data)
            this.shiftList = res.items
            //根据当时时间自动选择班次
            this.shiftList.forEach((item:any)=>{
                var curTime = new Date();
                var endTime = new Date(Date.parse(util.dateConversion(new Date())+' '+item.eddate));
                var startTime = new Date(Date.parse(util.dateConversion(new Date())+' '+item.stdate));
                if(curTime>=startTime && curTime<=endTime){
                    this.shiftActive = item
                }else{
                    // this.shiftActive = res.items[0]
                }
            })
        }
        //班次替换
        shiftChange(item:any){
            this.shiftActive = item
            this.getData()
        }

        //关注功能
        async focusOn(row:any){
            let data = {
                patientId:row.patientId,
                isFocusOn:!row.isFocusOn
            }
            let res = await FocusOn(data)
            if(res.status==1){
                this.getData()
            }
        }
        //计算透析时间


        //按钮操作
        actions(name:string,item:any){
            this.activePatient = item
            switch(name){
                case '透前称量':
                this.weightShow = true
                break;
                case '制定处方':
                this.makePresShow = true
                break;
                case '修改处方':
                this.makePresShow = true
                break;
                case '确认处方':
                this.verifyPrescriptionShow = true
                break;
                case '执行医嘱':
                this.makeAdviceShow = true
                case '制定医嘱':
                this.makeAdviceShow = true
                break;
                case '透析上机':
                this.dialysisBeginShow = true
                break;
                case '交叉核对':
                this.crosscheckShow = true
                break;
                case '记录并发症':
                this.dialysisSyndromeShow = true
                break;
                case '透中护理':
                this.dialysisNurseShow = true
                break;
                case '透析下机':
                if(this.activePatient.orderCount>0){
                    this.makeAdviceShow = true
                }else{
                    this.dialysisOffShow = true
                }
                break;
                case '透析小结':
                this.dialysisSummaryShow = true
                break;
                case '消毒':
                this.dialysisDisinfectShow = true
                break;
                case '特殊护理':
                this.specialCareShow = true
                break;
                case '标签管理':
                this.tagsManageShow = true
                break;
                case '关注':
                this.focusOn(item)
                break;
                case '取消关注':
                this.focusOn(item)
                break;
                case '删除排床':
                this.actionInfoShow = true
                this.actionInfoData = {
                    type:'error',
                    title:'删除排床',
                    content:'是否继续删除？'
                }
                break;
                case '取消本次透析':
                this.cancelDlyShow = true
                this.activePatient.canceltype = 0
                break;
                case '终止本次透析':
                this.cancelDlyShow = true
                this.activePatient.canceltype = 1
                break;
                case '换床':
                this.changeBedShow = true
                break;
                case '透析记录单':
                this.patDlyRecordShow = true
                break;
                case '透后称量':
                this.afterWeightShow = true
                break;
                case '设备报修':
                this.machieRepairShow = true
                break;
                case '借还药':
                this.borrowedMedicineShow = true
                break;
                case '宣教':
                this.educationShow = true
				this.educationData = {
                	data:{
                		row: {
                			patientId: item.patientId
						}
					}
				}
                break;
            }
        }

        //拼音搜索
        pyChange(index:any){
            this.pyindex = index
            if(index!=0){
                let list:any = []
                this.list.forEach((item:any)=>{
                    if(this.pylist[index] ==  PY.instance.initialTreatment(item.patientName)){
                        list.push(item)
                    }
                })
                this.listActive = list
            }else{
                this.listActive = this.list
            }
            clearInterval(this.tsetInterval)
            this.countDown = []
            this.countDownBl = []
            //透析活动时间计算开始
            this.listActive.forEach((item:any,index:any)=>{
                this.countDown.push('')
                this.countDownBl.push(0)
            })
            this.getprice(this.listActive)
        }



        roleName = ''
        //获取用户角色
        async getUserRoles(){
            let res = await GetUserRoles()
            this.roleName = res.objects[0].roleName
        }
        //new 一个定时任务
        tsetInterval:any = null;
        getprice(list:any){
            this.$nextTick(()=>{
                this.tsetInterval = setInterval(()=>{
                    this.listActive.forEach((item:any,index:number)=>{
                        let startTime = item.dlyStartDate;
                        let endTime = item.dlyEndDate;
                        if(!startTime){
                            this.countDown[index] = ''
                            this.countDownBl[index] = -1
                            this.$set(this.countDown,index,this.countDown[index])
                            this.$set(this.countDownBl,index,this.countDownBl[index])
                        }else{
                            //后台返回时间处理
                            startTime = startTime.replace(new RegExp(/T/gm) ," ");
                            endTime = endTime.replace(new RegExp(/T/gm) ," ");
                            startTime = startTime.replace(new RegExp(/-/gm) ,"/");
                            endTime = endTime.replace(new RegExp(/-/gm) ,"/");
                            startTime = startTime.split('.')[0]
                            endTime = endTime.split('.')[0];

                            this.countDown[index] = this.showCountDown(endTime)
                            //当前时间距离结束时间
                            let nowcount = new Date(endTime).getTime()-new Date().getTime();
                            //开始时间距离结束时间
                            let qcount = new Date(endTime).getTime()-new Date(startTime).getTime();
                            this.countDownBl[index] = parseInt(100-(nowcount/qcount)*100)
                            if(this.countDownBl[index]>=100){
                                this.countDownBl[index] = 100
                            }
                            this.$set(this.countDown,index,this.countDown[index])
                            this.$set(this.countDownBl,index,this.countDownBl[index])
                        }
                    })
                },1000)
            })
        }

        //计算透析时间
        getdlyTime(start:any,end:any){
            if(!start){
                return '00:00'
            }
            start = start.replace(new RegExp(/T/gm) ," ");
            end = end.replace(new RegExp(/T/gm) ," ");
            start = start.replace(new RegExp(/-/gm) ,"/");
            end = end.replace(new RegExp(/-/gm) ,"/");
            start = start.split('.')[0]
            end = end.split('.')[0]
            let leftTime:any=new Date(end).getTime()-new Date(start).getTime();
            if(leftTime<0){
                return '00:00'
            }
            let dd:any = parseInt(String(leftTime / 1000 / 60 / 60 / 24), 10);//计算剩余的天数
            let hh:any = parseInt(String(leftTime / 1000 / 60 / 60 % 24), 10);//计算剩余的小时数
            let mm:any = parseInt(String(leftTime / 1000 / 60 % 60), 10);//计算剩余的分钟数
            let ss:any = parseInt(String(leftTime / 1000 % 60), 10);//计算剩余的秒数
            dd = dd==0?"":this.toDub(dd)+"天";
            hh = hh==0?"":this.toDub(hh)+":";
            mm = mm==0?"":this.toDub(mm)+":";
            ss = ss==0?"00":this.toDub(ss);
            let ait = dd+hh+mm+ss
            return  ait
        }

        showCountDown(time:String){
            let now = new Date();
            let times=time.replace(new RegExp(/-/gm) ,"/");
            let endDate = new Date(times);
            let leftTime:any=endDate.getTime()-now.getTime();
            if(leftTime<0){
                return '00:00'
            }
            let dd:any = parseInt(String(leftTime / 1000 / 60 / 60 / 24), 10);//计算剩余的天数
            let hh:any = parseInt(String(leftTime / 1000 / 60 / 60 % 24), 10);//计算剩余的小时数
            let mm:any = parseInt(String(leftTime / 1000 / 60 % 60), 10);//计算剩余的分钟数
            let ss:any = parseInt(String(leftTime / 1000 % 60), 10);//计算剩余的秒数
            dd = dd==0?"":this.toDub(dd)+"天";
            hh = hh==0?"":this.toDub(hh)+"时";
            mm = mm==0?"":this.toDub(mm)+"分";
            ss = ss==0?"00":this.toDub(ss)+'秒';
            let ait = dd+hh+mm+ss
            return  ait
        }
        toDub(n:any){
            return n<10?"0"+n:""+n;
        }
        //异常警告
        warningInfo(){
            this.$Modal.warning({
                title: '1',
                content: '1'
            });
        }

    }



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/dialysisArea/index.vue